<script setup lang="ts">
    import type { MenuItem as WoomMenuItem } from '~/graphql/generated';

    export type HandleMenuKeypress = (params: { isOpen: boolean; event: KeyboardEvent; level: number; itemId?: string; submenuId?: string }) => void;

    export interface DestopMenuItemProps {
        handleMenuKeypress: HandleMenuKeypress;
        item: WoomMenuItem;
        to?: string;
        target?: string;
        menuLevel: number;
    }

    const props = defineProps<DestopMenuItemProps>();
    const emit = defineEmits<{
        (e: 'details', data: WoomMenuItem): void;
    }>();

    const nuxtApp = useNuxtApp();

    const isOpen = ref(false);

    const itemId = computed(() => {
        if (!props.item) return;
        return textToId(props.item.title);
    });

    const handleFocus = () => {
        isOpen.value = false;
    };
    const trackKeyboard = () =>
        nuxtApp.$gtm.pushEvent({
            event: 'click_navigation',
            navigation_menu_level: props.menuLevel,
            navigation_menu_id: textToId(props.item.title),
            interaction_type: 'keyboard',
        });
    const handleInteraction = (event: KeyboardEvent) => {
        if (!(event instanceof KeyboardEvent)) return;
        const key = event.code;
        // only space & enter trigger sub-menu open/close
        if (['Enter', 'NumpadEnter', 'Space'].includes(key)) {
            isOpen.value = !isOpen.value;
            if (isOpen.value) trackKeyboard();
        }
        props.handleMenuKeypress({
            isOpen: isOpen.value,
            event,
            level: props.menuLevel,
            itemId: props.item.id,
            submenuId: itemId.value,
        });
    };
    const handleBikeDetail = () => {
        emit('details', props.item);
    };
</script>
<template>
    <button
        v-if="item.items && (item?.items.length ?? 0)"
        :aria-expanded="isOpen"
        :aria-controls="`${itemId}-submenu`"
        :id="itemId"
        aria-haspopup="true"
        class="atm-desktop-menu-item flex items-center justify-between -outline-offset-1 transition-colors hover:text-woom-red focus:text-woom-red"
        type="button"
        @focus="handleFocus"
        @keydown.esc.tab.space.enter="handleInteraction($event)">
        <atm-menu-item
            :item="item"
            :is-first-level="menuLevel === 1" />
    </button>
    <nuxt-link
        v-else
        :to="to"
        :target="target"
        class="atm-desktop-menu-item gtm-click-navigation flex -outline-offset-1 transition-colors hover:text-woom-red focus:text-woom-red"
        @focus="handleBikeDetail"
        @keydown.enter="trackKeyboard()"
        @keydown.esc.tab="handleMenuKeypress({ event: $event, isOpen: false, level: menuLevel })"
        @mouseover="handleBikeDetail">
        <atm-menu-item
            :item="item"
            :is-first-level="menuLevel === 1" />
    </nuxt-link>
</template>
